import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const containerStyle = css({
  display: 'flex',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(1),
  marginLeft: theme.spacing(0.5),
});

export const searchFieldContainerStyle = css({
  flex: 1,
});

export const freemiumBadgeStyle = css`
  position: absolute;
  left: ${theme.spacing(18)};
  top: ${theme.spacing(0.5)};
  height: 24px;
  width: 24px;

  @media screen and (max-width: ${breakpoints.xsmall.max}px) {
    height: 20px;
    width: 20px;
  }
`;

export const relativeWrapperStyle = css({
  position: 'relative',
});
